module.exports = __webpack_public_path__ + "img/40_38_035_300.113c0fc1.jpg";